import { Radio, Card } from 'antd';
import { Question, EffectiveChoiceItem } from '../../types/survey.types';
import './ChoiceOptions.css';

// Phase 6 - US4: Multiple Choice Question Component (T115)

interface MultipleChoiceQuestionProps {
  question: Question;
  value?: string;
  onChange: (value: string) => void;
  /** Spec 033: lista já filtrada (botões de filtro + filtro digitado) a ser exibida. */
  visibleChoices?: EffectiveChoiceItem[];
}

const MultipleChoiceQuestion = ({ question, value, onChange, visibleChoices }: MultipleChoiceQuestionProps) => {
  const options = question.options as { choices?: Array<{ value: string; label: string }> };
  const choices =
    visibleChoices ??
    (question.effectiveChoices && question.effectiveChoices.length > 0
      ? question.effectiveChoices
      : options?.choices || []);

  return (
    <Radio.Group value={value} onChange={(e) => onChange(e.target.value)} style={{ width: '100%' }}>
      <div className="choice-options-grid">
        {choices.map((choice) => {
          const isSelected = value === choice.value;
          const cardClassName = ['choice-option-card', isSelected && 'choice-option-card--selected']
            .filter(Boolean)
            .join(' ');

          return (
            <Card
              key={choice.value}
              className={cardClassName}
              onClick={() => onChange(choice.value)}
              styles={{ body: { padding: '12px 16px' } }}
            >
              <Radio value={choice.value} checked={isSelected}>
                <span className="choice-option-label">{choice.label}</span>
              </Radio>
            </Card>
          );
        })}
      </div>
    </Radio.Group>
  );
};

export default MultipleChoiceQuestion;
